import Vue from 'vue';
import axios from 'axios';
import LoadScript from 'vue-plugin-load-script';
import { sync } from 'vuex-router-sync';
import skeleton from 'tb-skeleton';
import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';
import helpers from './helpers';
import VueSweetalert2 from 'vue-sweetalert2';
import { BootstrapVue } from 'bootstrap-vue';
import { datadogRum } from '@datadog/browser-rum';
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

Vue.use(LoadScript);
Vue.use(skeleton);

const options = {
  customClass: {
    closeButton: 'dialog-close',
    cancelButton: 'dialog-cancel',
    confirmButton: 'dialog-confirm',
    //content: '...',
    //htmlContainer: '...',
  }
};
Vue.use(VueSweetalert2, options);

sync(store, router);

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
 
Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.headers.common['Content-Language'] = i18n.locale;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
}

Vue.loadScript('/static/vendor/jQuery/jquery-3.5.1.min.js').then(() => {
  Vue.loadScript('/static/vendor/popper.min.js').then(() => {
    Vue.loadScript('/static/vendor/bootstrap-4.5.3-dist/js/bootstrap.min.js');
    Vue.loadScript('/static/js/script.js');
    Vue.loadScript('/static/js/select.js');
  });
});

Vue.prototype.helpers = helpers;

datadogRum.init({
    applicationId: 'a0514134-6969-4860-9ce5-a3acb347fc31',
    clientToken: 'pub77b1a1f051c628c19bee96b64531a2bc',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.eu',
    service: 'my.ug',
    env: 'production',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 0,
    sessionReplaySampleRate: 0,
    allowedTracingUrls: ["https://api.my.ug.edu.ge", /https:\/\/.*\.api.my.ug.edu\.ge/, (url) => url.startsWith("https://api.my.ug.edu.ge")],
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    trackInteractions: true,
    trackViewsManually: true,
    startSessionReplayRecordingManually: true,

    });

    router.afterEach((to, from) => {
  // console.log('Route changed from', from.fullPath, 'to', to.fullPath)

      if (to.fullPath === '/pre-registration') {
    datadogRum.startView({ name: 'pre-registration' });
    datadogRum.startSessionReplayRecording();
}
   if (to.fullPath === '/registration') {
    datadogRum.startView({ name: 'registration' });
    datadogRum.startSessionReplayRecording();
}
   if (to.fullPath === '/lab') {
    datadogRum.startView({ name: 'lab' });
    datadogRum.startSessionReplayRecording();
}


})







new Vue({
  el: '#app',
  functional: true,
  router,
  store,
  i18n,
  render(h) {
    return h(App);
  },
});
